import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Payment, Transaction } from 'src/app/models';
import { PATTERN } from 'src/app/constants/pattern';
import { SPLIT_VALIDATIONS } from 'src/app/core/constants/Errors';
import { GeneralTool } from './tools/general-tools';
import { ResponseSplitOrder } from 'src/app/models/responseSplitOrder';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { SplitPaymentService } from './services/split-payment.service';
import { AlertService } from 'src/app/services/alert.service';
import { GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { RequestSplitOrder } from 'src/app/models/requestSplitOrder';

@Component({
  selector: 'app-split-payment',
  templateUrl: './split-payment.component.html',
  styleUrls: ['./split-payment.component.scss']
})
export class SplitPaymentComponent implements OnInit {

  @Input() information: Payment;
  @Input() transaction: Transaction;
  @Output() SPLIT = new EventEmitter();

  splitForm: FormGroup;
  generalConstants = GENERAL_CONSTANTS;
  splitConstants = GENERAL_CONSTANTS.SPLIT_ORDERS_RESPONSE;
  errorsMessages = SPLIT_VALIDATIONS;
  template: string;
  buttonMessage = 'split-Button-text';
  defaultCurrency = 'COP';
  stepsMessage = 'subTitle-Split-Payment';
  splitErrorMessage = 'split-Step-Limit-Error';
  checkoutToken = '';
  loading = true;
  splitErrorInput = false;
  infoLinksTemplate = false;
  firstPayValue: number;
  secondPayValue: number;
  orderAmountTemp = 0;
  paymentList: ResponseSplitOrder['DATA'];

  constructor(
    private formBuilder: FormBuilder,
    private tokenService: TokenServiceService,
    private splitPaymentService: SplitPaymentService,
    private alertService: AlertService
  ) {
    this.splitForm = this.formBuilder.group({
      firstPayValue: ['', Validators.compose([
        Validators.required,
        Validators.min(1),
        Validators.pattern(PATTERN.PATTERN_ONLY_TWO_DECIMAL)
      ])],
      secondPayValue: ['', Validators.compose([
        Validators.required,
        Validators.min(1)
      ])],
    });
  }

  ngOnInit(): void {
    this.template = this.information.template;
    this.defaultCurrency = this.transaction.ORDER_CURRENCY;
    this.orderAmountTemp = Number(this.transaction.ORDER_AMOUT);
    this.splitForm.get('secondPayValue').disable();
    this.checkoutToken = this.tokenService.getToken();
    this.validateExistsOrder(this.checkoutToken);
  }
  /**
   * @description Function that returns to payment methods
  */
  changeMethod() {
    this.SPLIT.emit();
  }
  /**
   * @description {validateLimitInputs} Function to validate the amount that is entered with that of the general order
   * @param inputName input control
  */
  validateLimitInputs(inputName: string) {
    this.splitErrorInput = false;
    if (Number(this.splitForm.get(inputName).value) >= Number(this.orderAmountTemp)) {
      this.splitErrorInput = true;
      this.splitErrorMessage = 'split-Step-Limit-Error';
      return;
    }
  }
  /**
   * 
   * @description {updateSecondValue} Function to calculate the second value of the order
  */
  updateSecondValue() {
    let secondPaymentElement = document.getElementById('secondPayValue') as HTMLInputElement;
    secondPaymentElement.value = '';

    if (this.splitForm.get('firstPayValue').valid) {
      this.secondPayValue = this.orderAmountTemp - this.firstPayValue;
      let formatNumber = this.formatNumber(this.secondPayValue.toString());
      secondPaymentElement.value = formatNumber;
    }
  }
  /**
   * 
   * @description {formatNumber} Function to add decimals, tens and hundreds to the values of the order
   * @param inputValue 
   * @returns format value
  */
  formatNumber(inputValue: string) {
    return !isNaN(Number(inputValue)) ? GeneralTool.formatNumber(inputValue) : '';
  }
  /**
   * @description {generatePayment} Function to generate pay orders
  */
  generatePayment() {
    this.splitErrorInput = false;
    this.loading = true;
    if (GeneralTool.validateDecimal(Number(this.firstPayValue)) && this.transaction.ORDER_CURRENCY == 'COP') {
      this.splitErrorInput = true;
      this.splitErrorMessage = 'split-Payment-Error-Cents';
      this.loading = false;
      return;
    };
    let requestBody: RequestSplitOrder = {
      token: this.checkoutToken,
      payments: [
        { amount: this.firstPayValue.toString() },
        { amount: this.secondPayValue.toString() }
      ]
    };
    this.splitPaymentService.generateSplitOrder(requestBody).subscribe({
      next: (response) => {
        this.buildSplitResponse(response.CODE, response.DATA);
      }, error: () => {
        this.buildSplitResponse('');
      }
    });
  }

  /**
   * 
   * @description {validateExistsOrder} Function to returns the split orders associated with the order defined by the token. 
   * @param checkoutToken token checkout
  */
  validateExistsOrder(checkoutToken: string) {
    this.loading = true;
    this.splitPaymentService.validateExistsOrder(checkoutToken).subscribe({
      next: (response) => {
        if (response) {
          this.buildSplitResponse(response.CODE, response.DATA);
        }
      }, error: () => {
        this.buildSplitResponse('');
      }
    });
  }
  /**
   * 
   * @description {buildSplitResponse} Function to build splitOrder response and show alert
   * @param code response split code
  */
  buildSplitResponse(code: string, orderPaymentList?: ResponseSplitOrder['DATA']) {
    switch (code) {
      case this.generalConstants.OK_RESPONSE_CODE:
        this.paymentList = orderPaymentList;
        this.infoLinksTemplate = true;
        this.stepsMessage = 'split-Payment-Step-Two';
        break;
      case this.splitConstants.INVALID_TOKEN:
      case this.splitConstants.INTERNAL_ERROR:
        this.alertService.showAlert(this.generalConstants.GENERAL_ALERT);
        break;
      case this.splitConstants.NO_ORDERS_FOUND:
        this.infoLinksTemplate = false;
        break;
      default:
        this.alertService.showAlertProblem();
        break;
    }
    this.loading = false;
  }
}
